import type { TourDefinition } from "@tiny/tour";

export const aiTuningTour: TourDefinition = {
  id: "ai-tuning-setup-v1",
  promptTitle: "Set Up Your Brand Voice",
  promptDescription:
    "Train tinyAlbert on your brand in under 2 minutes — unlock AI-generated campaigns, automations, and forms that sound exactly like you.",
  steps: [
    {
      target: "body",
      title: "This Is Where the Magic Starts",
      content:
        "AI Tuning is the most important step in tinyAlbert. The information you provide here trains the AI to write emails in your exact tone, language, and style. Every campaign, automation, and form will be generated from these settings — so the more detail you give, the better the output.",
      placement: "center",
      skipBeacon: true,
    },
    {
      target: "[data-tour='ai-tuning-layout']",
      title: "1. Choose Your Email Layout",
      content:
        "Pick the structural layout that best represents your brand's email style. This layout is applied as the base template for all campaigns and automations tinyAlbert generates. You can preview each option before choosing — look for the one that matches your aesthetic.",
      placement: "bottom",
      skipBeacon: true,
    },
    {
      target: "#tone-of-voice",
      title: "2. Set Your Tone of Voice",
      content:
        "Tell tinyAlbert how your brand should sound. Options range from Professional and Formal to Friendly, Playful, or Bold. Every email tinyAlbert writes will consistently use this tone — so pick the one that resonates most with your customers.",
      placement: "bottom",
      skipBeacon: true,
    },
    {
      target: "#content-language",
      title: "3. Choose Content Language",
      content:
        "Select the language your audience speaks. tinyAlbert will generate all email copy — subject lines, body text, CTAs — in this language. If you serve customers in multiple regions, you'll want to set up separate accounts per language.",
      placement: "bottom",
      skipBeacon: true,
    },
    {
      target: "#account-details",
      title: "4. Describe Your Business",
      content:
        "This is the most important field. Write a detailed description of your business: what you sell, who your customers are, your unique value proposition, and what makes you different. The more specific you are, the more accurate and compelling tinyAlbert's copy will be. Aim for 3–5 sentences.",
      placement: "auto",
      skipBeacon: true,
    },
    {
      target: "#myaccount-aituning-generate",
      title: "5. Generate Your Templates",
      content:
        "Once everything is set, click Generate. tinyAlbert will instantly create personalized email templates for all your campaigns, automations, and forms — based exactly on the settings you've provided. This takes about 30 seconds and you only need to do it once (or whenever you update your brand).",
      placement: "auto",
      skipBeacon: true,
    },
  ],
};
